/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const putVaultPermissions = /* GraphQL */ `
  query PutVaultPermissions($input: PutVaultPermissionsInput!) {
    putVaultPermissions(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const getVaultPermissions = /* GraphQL */ `
  query GetVaultPermissions($input: VaultPermissionsInput!) {
    getVaultPermissions(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const getLLMModels = /* GraphQL */ `
  query GetLLMModels {
    getLLMModels {
      statusCode
      body
      __typename
    }
  }
`;
export const getCategories = /* GraphQL */ `
  query GetCategories {
    getCategories {
      statusCode
      body
      __typename
    }
  }
`;
export const putContactsFromList = /* GraphQL */ `
  query PutContactsFromList($input: PutContactsFromListInput) {
    putContactsFromList(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const getVehicleStockFilter = /* GraphQL */ `
  query GetVehicleStockFilter($input: GetVehicleStockFilterInput) {
    getVehicleStockFilter(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const putNotificationRead = /* GraphQL */ `
  query PutNotificationRead($input: PutReadNotificationInput!) {
    putNotificationRead(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const getNotification = /* GraphQL */ `
  query GetNotification($input: GetNotificationInput!) {
    getNotification(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const getImage = /* GraphQL */ `
  query GetImage($input: GetImageInput!) {
    getImage(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const putImage = /* GraphQL */ `
  query PutImage($input: PutImageInput!) {
    putImage(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const getCampaignRetryTemplate = /* GraphQL */ `
  query GetCampaignRetryTemplate($input: GetCampaignRetryTemplateInput!) {
    getCampaignRetryTemplate(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const getVehicleStockPictures = /* GraphQL */ `
  query GetVehicleStockPictures($input: GetVehiclesStockInput!) {
    getVehicleStockPictures(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const putGenerateAvatar = /* GraphQL */ `
  query PutGenerateAvatar($input: PutGenerateAvatar!) {
    putGenerateAvatar(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const deleteMarketingCampaign = /* GraphQL */ `
  query DeleteMarketingCampaign($input: DeleteMarketingCampaignInput!) {
    deleteMarketingCampaign(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const getUsers = /* GraphQL */ `
  query GetUsers($input: GetUserInput!) {
    getUsers(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const putUser = /* GraphQL */ `
  query PutUser($input: PutUserInput!) {
    putUser(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const getCustomers = /* GraphQL */ `
  query GetCustomers($input: GetCustomerInput) {
    getCustomers(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const getUploadUrlFile = /* GraphQL */ `
  query GetUploadUrlFile($input: PutFileInput!) {
    getUploadUrlFile(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const getUrlFile = /* GraphQL */ `
  query GetUrlFile($input: GetFileInput!) {
    getUrlFile(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const putCampaigns = /* GraphQL */ `
  query PutCampaigns($input: putCampaignsInput!) {
    putCampaigns(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const putCampaignMarketing = /* GraphQL */ `
  query PutCampaignMarketing($input: putCampaignMarketingInput!) {
    putCampaignMarketing(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const deleteCampaign = /* GraphQL */ `
  query DeleteCampaign($input: deleteCampignsInput!) {
    deleteCampaign(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const getCampaigns = /* GraphQL */ `
  query GetCampaigns($input: getCampignsInput!) {
    getCampaigns(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const getDefaultProjects = /* GraphQL */ `
  query GetDefaultProjects($input: getCampignsDefaultProjectsInput!) {
    getDefaultProjects(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const getContactFiles = /* GraphQL */ `
  query GetContactFiles($input: getContactFilesInput!) {
    getContactFiles(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const putAgent = /* GraphQL */ `
  query PutAgent($input: PutAgentInput!) {
    putAgent(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const getAgent = /* GraphQL */ `
  query GetAgent($input: GetAgentInput!) {
    getAgent(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const deleteAgent = /* GraphQL */ `
  query DeleteAgent($input: DeleteAgentInput!) {
    deleteAgent(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const getConversationChatAssistant = /* GraphQL */ `
  query GetConversationChatAssistant($input: AgentConversationInput!) {
    getConversationChatAssistant(input: $input) {
      id
      statusCode
      status
      body
      __typename
    }
  }
`;
export const preDeleteAgent = /* GraphQL */ `
  query PreDeleteAgent($input: PreDeleteAgentInput!) {
    preDeleteAgent(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const deleteAgentFile = /* GraphQL */ `
  query DeleteAgentFile($input: DeleteAgentFileInput!) {
    deleteAgentFile(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const getQuicksightEmbedUrl = /* GraphQL */ `
  query GetQuicksightEmbedUrl($input: getQuicksightEmbedUrlInput!) {
    getQuicksightEmbedUrl(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const getPermissionCatalogUser = /* GraphQL */ `
  query GetPermissionCatalogUser($input: GetUserPermissionsInput!) {
    getPermissionCatalogUser(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const getEvent = /* GraphQL */ `
  query GetEvent($input: GetEventInput!) {
    getEvent(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const getAction = /* GraphQL */ `
  query GetAction($input: getActionsInput!) {
    getAction(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const putEmailBlast = /* GraphQL */ `
  query PutEmailBlast($input: PutEmailBlastInput!) {
    putEmailBlast(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const getContactsSegment = /* GraphQL */ `
  query GetContactsSegment($input: GetContactsSegmentInput!) {
    getContactsSegment(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const cancelRun = /* GraphQL */ `
  query CancelRun($input: cancelRunInput) {
    cancelRun(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const putUserResources = /* GraphQL */ `
  query PutUserResources($input: PutUserResourcesInput!) {
    putUserResources(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const getResources = /* GraphQL */ `
  query GetResources($input: GetResourcesInput!) {
    getResources(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const getVehicleStockImages = /* GraphQL */ `
  query GetVehicleStockImages($input: GetVehicleStockImagesInput!) {
    getVehicleStockImages(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const getLogs = /* GraphQL */ `
  query GetLogs($input: GetLogsInput!) {
    getLogs(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const getInvokePersona = /* GraphQL */ `
  query GetInvokePersona($input: GetInvokePersonaInput!) {
    getInvokePersona(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const getInvokeInterview = /* GraphQL */ `
  query GetInvokeInterview($input: GetInvokeInterviewInput!) {
    getInvokeInterview(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const getNotes = /* GraphQL */ `
  query GetNotes($input: GetNotesInput!) {
    getNotes(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const putNotes = /* GraphQL */ `
  query PutNotes($input: PutNotesInput!) {
    putNotes(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const getCustomerMessages = /* GraphQL */ `
  query GetCustomerMessages($input: GetCustomerMessagesInput!) {
    getCustomerMessages(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const putCampaignMessage = /* GraphQL */ `
  query PutCampaignMessage(
    $message_id: String
    $campaign_id: String
    $updated_message: String
  ) {
    putCampaignMessage(
      message_id: $message_id
      campaign_id: $campaign_id
      updated_message: $updated_message
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const putPrompt = /* GraphQL */ `
  query PutPrompt($input: PutPromptInput!) {
    putPrompt(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const getPrompt = /* GraphQL */ `
  query GetPrompt($input: GetPromptInput!) {
    getPrompt(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
export const deletePrompt = /* GraphQL */ `
  query DeletePrompt($input: DeletePromptInput!) {
    deletePrompt(input: $input) {
      statusCode
      body
      __typename
    }
  }
`;
